//Modal

const searchModal = document.getElementById('search-modal')

// Initialize Algolia (lazy loading)
let algoliaClient = null;
let algoliaIndices = {};

// Initialize Algolia on first use to avoid timing issues
function initAlgolia() {
    if (!algoliaClient && window.algoliaConfig) {
        try {
            algoliaClient = algoliasearch(window.algoliaConfig.appId, window.algoliaConfig.searchKey);
            algoliaIndices = {
                main: algoliaClient.initIndex(window.algoliaConfig.indices.main),
                brochures: algoliaClient.initIndex(window.algoliaConfig.indices.brochures),
                projects: algoliaClient.initIndex(window.algoliaConfig.indices.projects)
            };
        } catch (error) {
            console.error('Failed to initialize Algolia:', error);
        }
    }
    return algoliaClient !== null;
}

searchModal.addEventListener('show.bs.modal', () => {
    $('body').addClass('is-searching');
    if ($('body').hasClass('body-mobile-menu-open')){
        $('body').removeClass('body--fixed');
    }
})

searchModal.addEventListener('shown.bs.modal', () => {
    $( ".js-close-search" ).focus();
})

searchModal.addEventListener('hidden.bs.modal', () => {
    // Check if current URL is /search and handle navigation
    if (window.location.pathname === '/search') {
        // Check if referrer is from the same domain
        const referrer = document.referrer;
        const currentHost = window.location.host;
        
        if (referrer && referrer.includes(currentHost) && !referrer.includes('/search')) {
            // Go back to previous page if it's from the same website and not the search page
            window.history.back();
        } else {
            // Redirect to home page if no valid referrer or referrer is external
            window.location.href = '/';
        }
    } else {
        $('body').removeClass('is-searching');
        if ($('body').hasClass('body-mobile-menu-open')){
            $('body').addClass('body--fixed');
        }
    }
})

//Search

$(document).ajaxStart(function(){
    $('.ajax-loader').fadeIn();
});
$(document).ajaxComplete(function(){
    $('.ajax-loader').fadeOut();
});
$("#search").keyup(function(event) {
    if (event.keyCode === 13) {
        $("#submit-filters").click();
    }
});

$('#search').keyup(_.debounce(doSearch, 500));
$('#search').keyup(_.debounce(handleDatalayerSearch , 2000));

var historySupport = !!(window.history && history.pushState);

function doSearch(){
    var search = $('#search').val();
    if (search.length == 0){
        $('#query-container').fadeOut();
    } else {
        if($('#search')[0].checkValidity()){
            ajaxCall(search);
        }
        else{
            $.fancybox.open($("#search-error"));
        }
    }

}

function handleDatalayerSearch(){
    var search = $('#search').val();
    if (search.length > 2){
        if (typeof window.dataLayer !== "undefined") {
            window.dataLayer.push({  
                'event': 'main_site_search',  
                'search_term': search,  
            }); 
        }
    }
}

function handleDatalayerSearchResults(searchQuery){
    let searchResults = document.querySelectorAll('.search-result a');
    if (searchResults){
        searchResults.forEach( result => {
            result.addEventListener('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                let linkText = result.querySelector('.search-result__title').innerText;
                let linkUrl = result.href;
                window.dataLayer.push({ 
                    'event': 'main_site_search_result', 
                    'search_term': searchQuery, 
                    'link_text': linkText, 
                    'link_url': linkUrl
                    // 'eventCallback': () =>  { 
                    //     if (result.getAttribute('target') === '_blank'){
                    //         window.open(linkUrl);
                    //     } else {
                    //         window.location = linkUrl; 
                    //     }
                    // },
                    // 'eventTimeout' : 2000 
                }); 
                //Including the settimeout causes some devices to open it multiple times??? 
                setTimeout(() => {
                    if (result.getAttribute('target') === '_blank'){
                        window.open(linkUrl);
                    } else {
                        window.location = linkUrl; 
                    }
                }, 400);
            })
        })
    }
}

function ajaxCall(search){
    $('.search-panel__loading').fadeIn();
    $('#query-container').fadeOut();

    // Initialize Algolia if not already done (lazy loading to avoid timing issues)
    initAlgolia();

    // Always use Algolia
    if (algoliaClient && algoliaIndices.main) {
        // Perform Algolia search
        Promise.all([
            algoliaIndices.main.search(search, { hitsPerPage: 100 }),
            algoliaIndices.brochures.search(search, { hitsPerPage: 50 }),
            algoliaIndices.projects.search(search, { hitsPerPage: 50 })
        ]).then(results => {
            // Combine all hits with their relevance position
            let allHits = [];
            
            // Add hits from main index
            results[0].hits.forEach((hit, position) => { 
                hit._index = 'main';
                hit._relevancePosition = position; // Position in Algolia results (0 = most relevant)
                allHits.push(hit);
            });
            
            // Add hits from brochures
            results[1].hits.forEach((hit, position) => { 
                hit._index = 'brochures';
                hit._relevancePosition = position;
                allHits.push(hit);
            });
            
            // Add hits from projects
            results[2].hits.forEach((hit, position) => { 
                hit._index = 'projects';
                hit._relevancePosition = position;
                allHits.push(hit);
            });
            
            // Sort by relevance tiers, then by rankOrder within each tier
            const queryLower = search.toLowerCase();
            
            allHits.sort((a, b) => {
                // Determine if query appears in title
                const aInTitle = (a.title || '').toLowerCase().includes(queryLower);
                const bInTitle = (b.title || '').toLowerCase().includes(queryLower);
                
                // Determine relevance tier
                const getRelevanceTier = (hit, inTitle) => {
                    if (inTitle) return 1; // Tier 1: Query in title
                    if (hit._relevancePosition <= 5) return 2; // Tier 2: High relevance
                    if (hit._relevancePosition <= 15) return 3; // Tier 3: Medium relevance
                    return 4; // Tier 4: Lower relevance
                };
                
                const aTier = getRelevanceTier(a, aInTitle);
                const bTier = getRelevanceTier(b, bInTitle);
                
                // First sort by relevance tier
                if (aTier !== bTier) {
                    return aTier - bTier;
                }
                
                // Within the same tier, sort by rankOrder
                const aRankOrder = a.rankOrder || 99;
                const bRankOrder = b.rankOrder || 99;
                return aRankOrder - bRankOrder;
            });
            
            // Pass to server for HTML generation with Algolia results
            $.ajax('/views/hidden/search-ajax-request?&q='+search, {
                method: 'POST',
                data: JSON.stringify({ 
                    hits: allHits,
                    query: search // Pass the query for template to use
                }),
                contentType: 'application/json',
                dataType : 'html',
                success : function (response) {
                    $('.search-panel__loading').fadeOut();
                    refreshResults(response, search);
                    $('#query-container').fadeIn();
                    initSearchFiltering();
                    window.history.pushState({}, '', '/search?q=' + search);
                    if (typeof window.dataLayer !== "undefined") {
                        handleDatalayerSearchResults(search)
                    }
                }
            });
        }).catch(error => {
            console.error('Algolia search error:', error);
            $('.search-panel__loading').fadeOut();
            $('#query-container').html('<p>Search is temporarily unavailable. Please try again later.</p>').fadeIn();
        });
    } else {
        $('.search-panel__loading').fadeOut();
        $('#query-container').html('<p>Search configuration error. Please contact support.</p>').fadeIn();
    }
}

function refreshResults (html, search) {
    var $html = $('<div />').append(html);
    $('#query-container').html($html.find('.js-search-results').html()).fadeIn();
}

// Filtering

function initSearchFiltering(){

    let listOfFilters = document.querySelectorAll('.search-filters__filter-li button');
    let searchActiveFilter = 'all';

    if (listOfFilters) {
        listOfFilters.forEach( filter => {
            filter.addEventListener('click', function(e){
                searchActiveFilter = e.currentTarget.getAttribute('data-filter');
                updateSearchFilter(searchActiveFilter)
            })
        })
        updateSearchFilter('all')
    }

    let sortSelect = document.querySelector('.js-search-sort');
    if (sortSelect) {
        sortSelect.addEventListener('change', function(e){
            sortSearch(e.target.value)
        })
        sortSearch('relevance'); //initial sort
    }
}

function updateSearchFilter(filterToSet){

    //reset
    document.querySelectorAll('.active-search-filter').forEach( filter => {
        filter.classList.remove('active-search-filter')
    })
    document.querySelectorAll('.search-result').forEach( result => {
        result.classList.remove('search-result--hide')
    })

    //add class to filter button
    let newFilter = document.querySelector(`.search-filters__filter-li button[data-filter="${filterToSet}"]`);
    if (newFilter){
        newFilter.classList.add('active-search-filter')
    }

    let searchFilter = filterToSet;
    switch (searchFilter) {
        case 'capabilities':
            searchFilter = 'capability';
            break;
        case 'solutions':
            searchFilter = 'solution';
            break;
        case 'projects':
            searchFilter = 'project';
            break;
        case 'certifications':
            searchFilter = 'certification';
            break;
    }

    //filter list
    if (searchFilter !== 'all'){
        document.querySelectorAll('.search-result').forEach( result => {
            if (result.getAttribute('data-result-type') !== searchFilter ){
                result.classList.add('search-result--hide')
            }
        })
    }

    //update number of found results
    let results = document.querySelector('.search-results__total');
    let numberOfResults = document.querySelectorAll('.search-result:not(.search-result--hide)');
    if (results && numberOfResults) {
        results.innerHTML = numberOfResults.length + " Results"
    }

}

function sortSearch(sortType){
    let results = document.querySelectorAll('.search-result');
    if (!results) return;

    results = Array.from(results);

    if (sortType == 'relevance'){
        results.sort((a, b) => b.getAttribute('data-score') - a.getAttribute('data-score'))
    }

    if (sortType == 'most-recent'){
        results.sort((a, b) => Date.parse(b.getAttribute('data-date')) - Date.parse(a.getAttribute('data-date')))
    }

    let resultsList = document.querySelector("#search-results-scroller .search-results__list");
    if (resultsList) {
        for (let result of results) {
            resultsList.appendChild(result)
        }
    }
}

function toggleMobileFilters(){
    if ($('.search-filters').length < 1){
        $('.search-modal__mobile-filters-warning').addClass("search-modal__mobile-filters-warning--active")
    } else {
        $('.search-modal__mobile-filters-warning').removeClass("search-modal__mobile-filters-warning--active")
        $('.search-modal__mobile-filter-toggle').toggleClass('search-modal__mobile-filter-toggle--active');
        $('#query-container').toggleClass('show-filters');
    }
}

let mobileSearchFilters = document.querySelector(".js-search-mobile-filter-toggle");
if (mobileSearchFilters){
    mobileSearchFilters.addEventListener("click", function(){
        toggleMobileFilters();
    })
}

// URL handling for search
$(document).ready(function() {
    const currentPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get('q');
    
    if (currentPath === '/search') {
        // Open the search modal
        const modal = bootstrap.Modal.getOrCreateInstance(searchModal);
        modal.show();
        
        // If there's a query parameter, populate and trigger search
        if (searchQuery) {
            // Wait for modal to be shown before setting value and triggering search
            searchModal.addEventListener('shown.bs.modal', function handleSearchQuery() {
                $('#search').val(decodeURIComponent(searchQuery));
                doSearch();
                
                // Remove the event listener to prevent it from firing multiple times
                searchModal.removeEventListener('shown.bs.modal', handleSearchQuery);
            }, { once: true });
        }
    }
});